const KEY = "specialPermitData";
export const VEHICLE_DATA_KEY = "vehicleData";
export const updateSessionStorage = (data: any) => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  }
};

export const updateSessionStorageForKey = (key: string, data: any) => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
};

export const getSessionStorageForKey = (key: string) => {
  if (typeof window !== "undefined") {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }
};

export const clearSessionStorageForKey = (key: string) => {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(key);
  }
};

export const getSessionStorage = () => {
  if (typeof window !== "undefined") {
    const data = sessionStorage.getItem(KEY);
    return data ? JSON.parse(data) : null;
  }
};

export const clearSessionStorage = () => {
  if (typeof window !== "undefined") {
    sessionStorage.removeItem(KEY);
  }
};
